var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function SaveIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 9.00298C15 9.55362 14.5537 10 14.0025 10H6.99754C6.44662 10 6 9.55275 6 9.00298V3.99887L3.99581 3.99865V19.9987H6V14.9954C6 14.4457 6.44851 14 7.00247 14H16.9975C17.5512 14 18 14.4491 18 14.9954V19.9987H19.9958L20.017 7.84533L16.1744 3.99997L15 3.99984V9.00298ZM10 3.9993V8.00001H13V3.99963L10 3.9993ZM4.00001 21.9965C2.89544 21.9965 2 21.0983 2 19.9965V3.99654C2 2.89197 2.89615 1.99674 4.00107 1.99701L16.5009 2.00001C16.7766 2.00001 17.1551 2.15513 17.3516 2.3516L21.6484 6.64842C21.8426 6.84259 22 7.22369 22 7.49908V19.9959C22 21.1008 21.1018 21.9965 20 21.9965H4.00001ZM16 16H8V19.9987H16V16Z", fill: "" })));
}
export var SaveIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: SaveIconInner }, props))); };
//# sourceMappingURL=SaveIcon.js.map